import { render, staticRenderFns } from "./MinhasChaves.vue?vue&type=template&id=40b76aee"
import script from "./MinhasChaves.vue?vue&type=script&lang=ts"
export * from "./MinhasChaves.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports